import {
  getLastUpdateTime,
  findList,
  getDetail,
  getConceptList,
  getTrendList,
  getBasfProductSegment,
  getFormulationSegment,
  getFormulationList,
  getBasfProductList,
  setComment,
  getKeywordList
} from '@/axios/api/eventClient'
const state = {
  listData: [],
  pager: {
    current: 1,
    size: 12
  },
  total: 0,
  relatedTrendList: [],
  trendPager: {
    current: 1,
    size: 999
  },
  trendTotal: 0,
  relatedConceptList: [],
  conceptPager: {
    current: 1,
    size: 999
  },
  conceptTotal: 0,
  detail: {},
  formulationSegment: [],
  basfProductSegment: [],
  basfProductSegmentPager: {
    current: 1,
    size: 10
  },
  formulationSegmentPager: {
    current: 1,
    size: 10
  },
  basfProductSegmentTotal: 0,
  formulationSegmentTotal: 0,
  basfProductSegmentListPager: {
    current: 1,
    size: 10
  },
  formulationSegmentListPager: {
    current: 1,
    size: 10
  },
  basfProductSegmentListTotal: 0,
  formulationSegmentListTotal: 0
}

const getters = {
  listData: state => state.listData,
  pager: state => state.pager,
  total: state => state.total,
  relatedTrendList: state => state.relatedTrendList.map(v => {
    return {
      ...v,
      coverImg: v.imgSrc,
      desc: v.description
    }
  }),
  trendPager: state => state.trendPager,
  trendTotal: state => state.trendTotal,
  relatedConceptList: state => state.relatedConceptList.map(v => {
    return {
      ...v,
      coverImg: v.imgSrc,
      desc: v.internationalDesc
    }
  }),
  conceptPager: state => state.conceptPager,
  conceptTotal: state => state.conceptTotal,
  detail: state => state.detail,
  formulationSegment: state => state.formulationSegment,
  basfProductSegment: state => state.basfProductSegment,
  basfProductSegmentPager: state => state.basfProductSegmentPager,
  formulationSegmentPager: state => state.formulationSegmentPager,
  basfProductSegmentTotal: state => state.basfProductSegmentTotal,
  formulationSegmentTotal: state => state.formulationSegmentTotal,

  basfProductSegmentListPager: state => state.basfProductSegmentListPager,
  formulationSegmentListPager: state => state.formulationSegmentListPager,
  basfProductSegmentListTotal: state => state.basfProductSegmentListTotal,
  formulationSegmentListTotal: state => state.formulationSegmentListTotal

}

const UPDATE_LIST_DATA = 'UPDATE_LIST_DATA'
const UPDATE_PAGER = 'UPDATE_PAGER'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_TREND_DATA = 'UPDATE_TREND_DATA'
const UPDATE_TREND_PAGER = 'UPDATE_TREND_PAGER'
const UPDATE_TREND_TOTAL = 'UPDATE_TREND_TOTAL'
const UPDATE_CONCEPT_DATA = 'UPDATE_CONCEPT_DATA'
const UPDATE_CONCEPT_PAGER = 'UPDATE_CONCEPT_PAGER'
const UPDATE_CONCEPT_TOTAL = 'UPDATE_CONCEPT_TOTAL'
const UPDATE_DETAIL = 'UPDATE_DETAIL'
const UPDATE_FORMULATION_SEGMENT = 'UPDATE_FORMULATION_SEGMENT'
const UPDATE_BASF_PRODUCT_SEGMENT = 'UPDATE_BASF_PRODUCT_SEGMENT'
const UPDATE_BASF_PRODUCT_SEGMENT_TOTAL = 'UPDATE_BASF_PRODUCT_SEGMENT_TOTAL'
const UPDATE_FORMULATION_SEGMENT_TOTAL = 'UPDATE_FORMULATION_SEGMENT_TOTAL'
const UPDATE_FORMULATION_SEGMENT_PAGER = 'UPDATE_FORMULATION_SEGMENT_PAGER'
const UPDATE_BASF_PRODUCT_SEGMENT_PAGER = 'UPDATE_BASF_PRODUCT_SEGMENT_PAGER'

const UPDATE_BASF_PRODUCT_SEGMENT_LIST_TOTAL = 'UPDATE_BASF_PRODUCT_SEGMENT_LIST_TOTAL'
const UPDATE_FORMULATION_SEGMENT_LIST_TOTAL = 'UPDATE_FORMULATION_SEGMENT_LIST_TOTAL'
const UPDATE_FORMULATION_SEGMENT_LIST_PAGER = 'UPDATE_FORMULATION_SEGMENT_LIST_PAGER'
const UPDATE_BASF_PRODUCT_SEGMENT_LIST_PAGER = 'UPDATE_BASF_PRODUCT_SEGMENT_LIST_PAGER'

const mutations = {
  [UPDATE_LIST_DATA] (state, listData) {
    state.listData = listData
  },
  [UPDATE_PAGER] (state, pager) {
    state.pager = pager
  },
  [UPDATE_TOTAL] (state, total) {
    state.total = total
  },
  [UPDATE_TREND_DATA] (state, listData) {
    state.relatedTrendList = listData
  },
  [UPDATE_TREND_PAGER] (state, pager) {
    state.trendPager = pager
  },
  [UPDATE_TREND_TOTAL] (state, total) {
    state.trendTotal = total
  },
  [UPDATE_CONCEPT_DATA] (state, listData) {
    state.relatedConceptList = listData
  },
  [UPDATE_CONCEPT_PAGER] (state, pager) {
    state.conceptPager = pager
  },
  [UPDATE_CONCEPT_TOTAL] (state, total) {
    state.conceptTotal = total
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  },
  [UPDATE_FORMULATION_SEGMENT] (state, listData) {
    state.formulationSegment = listData
  },
  [UPDATE_BASF_PRODUCT_SEGMENT] (state, listData) {
    state.basfProductSegment = listData
  },
  [UPDATE_FORMULATION_SEGMENT_TOTAL] (state, total) {
    state.formulationSegmentTotal = total
  },
  [UPDATE_BASF_PRODUCT_SEGMENT_TOTAL] (state, total) {
    state.basfProductSegmentTotal = total
  },
  [UPDATE_FORMULATION_SEGMENT_PAGER] (state, pager) {
    state.formulationSegmentPager = pager
  },
  [UPDATE_BASF_PRODUCT_SEGMENT_PAGER] (state, pager) {
    state.basfProductSegmentPager = pager
  },
  [UPDATE_FORMULATION_SEGMENT_LIST_TOTAL] (state, total) {
    state.formulationSegmentListTotal = total
  },
  [UPDATE_BASF_PRODUCT_SEGMENT_LIST_TOTAL] (state, total) {
    state.basfProductSegmentListTotal = total
  },
  [UPDATE_FORMULATION_SEGMENT_LIST_PAGER] (state, pager) {
    state.formulationSegmentListPager = pager
  },
  [UPDATE_BASF_PRODUCT_SEGMENT_LIST_PAGER] (state, pager) {
    state.basfProductSegmentListPager = pager
  }
}

const actions = {
  // 请求页面头部信息
  async getLastUpdateTimeApi ({ state, commit }, params) {
    try {
      let { data: res } = await getLastUpdateTime({...params})
      return res
    } catch (e) {
      return {}
    }
  },
  // 获取列表
  async findListApi ({ state, commit }, params) {
    try {
      let { data: res } = await findList({...params})
      commit(UPDATE_LIST_DATA, res.list || [])
      commit(UPDATE_TOTAL, res.total || 0)
    } catch (e) {
    }
  },
  // 设置page
  setPagerApi ({commit}, pager) {
    commit(UPDATE_PAGER, pager)
  },
  // 设置page
  setConceptPagerApi ({commit}, pager) {
    commit(UPDATE_CONCEPT_PAGER, pager)
  },
  // 设置page
  setTrendPagerApi ({commit}, pager) {
    commit(UPDATE_TREND_PAGER, pager)
  },
  // 设置page
  setBasfProductSegmentPagerApi ({commit}, pager) {
    commit(UPDATE_BASF_PRODUCT_SEGMENT_PAGER, pager)
  },
  // 设置page
  setFormulationSegmentPagerApi ({commit}, pager) {
    commit(UPDATE_FORMULATION_SEGMENT_PAGER, pager)
  },
  // 设置page
  setBasfProductSegmentListPagerApi ({commit}, pager) {
    commit(UPDATE_BASF_PRODUCT_SEGMENT_LIST_PAGER, pager)
  },
  // 设置page
  setFormulationSegmentListPagerApi ({commit}, pager) {
    commit(UPDATE_FORMULATION_SEGMENT_LIST_PAGER, pager)
  },
  // 获取详情
  async getDetailApi ({ state, commit }, params) {
    try {
      let { data: res } = await getDetail(params)
      commit(UPDATE_DETAIL, res.data)
      return res.data
    } catch (e) {
    }
  },
  // 获取Concept列表
  async getConceptListApi ({ state, commit }, params) {
    try {
      let { data: res } = await getConceptList({...params})
      commit(UPDATE_CONCEPT_DATA, res.records || [])
      commit(UPDATE_CONCEPT_TOTAL, res.total || 0)
    } catch (e) {
    }
  },
  // 获取Trend列表
  async getTrendListApi ({ state, commit }, params) {
    try {
      let { data: res } = await getTrendList({...params})
      commit(UPDATE_TREND_DATA, res.records || [])
      commit(UPDATE_TREND_TOTAL, res.total || 0)
    } catch (e) {
    }
  },
  // 获取BasfProduct分类
  async getBasfProductSegmentApi ({ state, commit }, params) {
    try {
      let { data: res } = await getBasfProductSegment({...params, size: 50})
      commit(UPDATE_BASF_PRODUCT_SEGMENT, res.records || [])
      commit(UPDATE_BASF_PRODUCT_SEGMENT_TOTAL, res.total || 0)
    } catch (e) {
    }
  },
  // 获取Formulation分类
  async getFormulationSegmentApi ({ state, commit }, params) {
    try {
      let { data: res } = await getFormulationSegment({...params, size: 50})
      commit(UPDATE_FORMULATION_SEGMENT, res.records || [])
      commit(UPDATE_FORMULATION_SEGMENT_TOTAL, res.total || 0)
    } catch (e) {
    }
  },
  // 获取Formulation列表
  async getFormulationListApi ({ state, commit }, params) {
    try {
      let { data: res } = await getFormulationList({...params})
      commit(UPDATE_FORMULATION_SEGMENT_LIST_TOTAL, res.formulationList && res.formulationList.total || 0)
      return res || []
    } catch (e) {
    }
  },
  // 获取BasfProduct列表
  async getBasfProductListApi ({ state, commit }, params) {
    try {
      let { data: res } = await getBasfProductList({...params})
      commit(UPDATE_BASF_PRODUCT_SEGMENT_LIST_TOTAL, res.basfProducts && res.basfProducts.total || 0)
      return res || []
    } catch (e) {
    }
  },
  // 评论
  async setCommentApi ({ state, commit }, params) {
    try {
      let res = await setComment({...params})
      return res.errorCode === 200
    } catch (e) {
    }
  },
  // 获取keyword列表
  async getKeywordListApi ({ state, commit }, params) {
    try {
      let { data: res } = await getKeywordList({...params})
      return res.listData || []
    } catch (e) {
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/eventClient.js